<div class="global-search-container mx-0 my-0 p-0">
  <!-- Badges in horizontal row -->
  <div class="badge-container  pt-3 pb-2">
    <div *ngFor="let badge of badges"
      class="custom-badge1 cursor-pointer"
      [ngClass]="{'bg-primary text-white': badge.id === selectedBadgeId}"
      (click)="badge.type === 'Recent Search' ? onClickRecentSearch() : setSearchQuery(badge.type)">
      {{ badge.type }}
    </div>
  </div>

  <hr class="heading-bottom-rule" *ngIf="isRecentSearch || hasSearchResults() || isSkeletonLoader || noResultFound">

  <div class="search-suggestions mt-0" *ngIf="isRecentSearch" @fadeInOut>
    <div class="container p-0 mt-0 recent-searches">
      <!-- Tab Navigation for Recent/Past Searches -->
      <div class="sticky-top">
        <div class="search-tabs-container">
          <!-- Recent Searches Tab -->
          <button
            class="search-tab"
            [ngClass]="{'active': !showPastSearches}"
            (click)="switchToRecentSearches()">
             <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                    stroke="#404040"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.5001 17.5L13.9167 13.9167"
                    stroke="#404040"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
            <span>Recent Searches</span>
            <span class="tab-count" *ngIf="!showPastSearches">{{ recentSearches.length }}</span>
          </button>

          <!-- Past Searches Tab -->
          <button
            class="search-tab"
            [ngClass]="{'active': showPastSearches}"
            (click)="switchToPastSearches()">
            <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 0H1.66667C0.75 0 0.00833333 0.75 0.00833333 1.66667L0 11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H15C15.9167 13.3333 16.6667 12.5833 16.6667 11.6667V1.66667C16.6667 0.75 15.9167 0 15 0ZM15 3.33333L8.33333 7.5L1.66667 3.33333V1.66667L8.33333 5.83333L15 1.66667V3.33333Z" fill="#121212"/>
</svg>

            <span>Past Searches</span>
            <span class="tab-count" *ngIf="showPastSearches">{{ companySearchHistory.length }}</span>
          </button>
        </div>
      </div>
      <!-- Display Searches -->
      <div class="searches-list-scrollable"
           #searchesListScrollable
           [class.has-scroll]="isSearchesListScrollable"
           [class.scrolled-bottom]="isSearchesListScrolledToBottom"
           (scroll)="onSearchesListScroll($event)">
        <!-- Skeleton Loader for Search History -->
        <div *ngIf="isLoadingSearchHistory" @fadeInOut class="skeleton-loader-container-history">
          <div class="skeleton-search-card" *ngFor="let item of [1,2,3,4,5]">
            <div class="skeleton-search-left">
              <div class="skeleton-badge"></div>
              <div class="skeleton-text-line skeleton-name"></div>
            </div>
            <div class="skeleton-search-center">
              <div class="skeleton-text-line skeleton-detail"></div>
              <div class="skeleton-text-line skeleton-detail short"></div>
            </div>
            <div class="skeleton-search-right">
              <div class="skeleton-text-line skeleton-time"></div>
            </div>
          </div>
        </div>

        <!-- Actual Search List -->
        <div class="searches-list" *ngIf="!isLoadingSearchHistory && getFilteredSearches().length > 0">
        <div *ngFor="let search of getFilteredSearches()" class="search-item-card"
          (click)="handleResultClick(
            search.activeTab?.toLowerCase() === 'customers'
              ? search.items?.customerId || search.items?.CustomerID ||search.itemData?.CustomerID ||search.itemData?.customerId
              : search.activeTab?.toLowerCase() === 'subscriptions'
              ? search.items?.subscriptionId
              : search.activeTab?.toLowerCase() === 'tickets'
              ? search.items?.id
              : search.activeTab?.toLowerCase() === 'orders'
              ? search.items?.id
              : search.activeTab?.toLowerCase() === 'payments'
              ? { id: search.items?.id, source: search.items?.source, customerId: search.items?.customerId || search.items?.customer_id }
              : search.items?.id,
            search.activeTab,
            search.activeTab?.toLowerCase() === 'orders' ? search.items?.customerId : search.activeTab?.toLowerCase() === 'subscriptions' ? search.items?.customerId || search.items?.CustomerId : search.activeTab?.toLowerCase() === 'payments' ? search.items?.customer_id || search.items?.customerId : undefined,
            search.searchTerm, search
          )">

          <!-- Count Badge (top-right corner) -->
          <div class="search-count-badge" *ngIf="search.searchCount > 1" (click)="$event.stopPropagation()">
            <span class="badge-count">{{ search.searchCount }}</span>

            <!-- Hover Tooltip -->
            <div class="search-count-tooltip"
                 [class.has-scroll]="isTooltipScrollable(search)"
                 [class.scrolled-bottom]="isTooltipScrolledToBottom(search)">
              <div class="tooltip-header">Search History ({{ search.searchCount }} times)</div>
              <div class="tooltip-content"
                   #tooltipContent
                   (scroll)="onTooltipScroll($event, search)">
                <div *ngFor="let historyItem of search.allSearchTimestamps" class="tooltip-item">
                  <span class="tooltip-date timestamp-date">
                    {{ commonService.formatToLocalDateTime(historyItem.timestamp, 'date') }}
                  </span>
                  <span class="tooltip-time timestamp-date">
                    {{ commonService.formatToLocalDateTime(historyItem.timestamp, 'time') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Left Section: ID Badge + Entity Name -->
          <div class="search-item-left">
            <!-- ID Badge -->
            <div class="search-id-badge-new" [innerHTML]="getHighlightedDisplayId(search)">
            </div>

            <!-- Entity Name/Title -->
            <div class="search-entity-name">
              {{ search.displayName }}
            </div>
          </div>

          <!-- Center Section: Search Details - Split into two containers -->
          <div class="search-item-center">
            <!-- First Container: Search Details (with wrapping support) -->
            <div class="search-details-container">
              <!-- Search Term Row with highlighting -->
              <div class="search-detail-row">
                <span class="search-detail-label">Search Term:</span>
                <span class="search-detail-value" [innerHTML]="getHighlightedSearchTerm(search)"></span>
              </div>

              <!-- Tab Selected Row -->
              <div class="search-detail-row">
                <span class="search-detail-label">Tab :</span>
                <span class="search-detail-value">{{ search.activeTab }}</span>
              </div>

              <!-- Specific ID Row (Order ID, Payment ID, Subscription ID, Ticket ID) -->
              <div class="search-detail-row" *ngIf="getSpecificIdLabel(search.activeTab)">
                <span class="search-detail-label">{{ getSpecificIdLabel(search.activeTab) }}:</span>
                <span class="search-detail-value" [innerHTML]="getHighlightedSpecificId(search)"></span>
              </div>
            </div>

            <!-- Second Container: Date and Time (fixed position) -->
            <div class="search-datetime-container">
              <div class="search-item-right">
                <span class="timestamp-date">
                  {{ commonService.formatToLocalDateTime(search.timestamp, 'date') }}
                </span>
                <span class="separator">|</span>
                <span class="timestamp-time">
                  {{ commonService.formatToLocalDateTime(search.timestamp, 'time') }}
                </span>
              </div>
            </div>
          </div>

          <!-- Right Section: Timestamp -->

        </div>
        </div>

        <!-- No Searches Message -->
        <div *ngIf="!isLoadingSearchHistory && getFilteredSearches().length <= 0" class="text-center mt-3 p-3">
          <p class="text-muted font-weight-bold">No {{ showPastSearches ? 'Past' : 'Recent' }} Searches</p>
        </div>
      </div>
    </div>
  </div>
    <!-- Show tabs when there are search results or loading -->
    <div class="div" *ngIf="searchQuery && (hasSearchResults() || isSkeletonLoader || noResultFound)" @fadeInOut>
      <div #searchResultsContainer
           class="search-suggestions"
           [class.has-scroll]="isSearchResultsScrollable"
           [class.scrolled-bottom]="isSearchResultsScrolledToBottom"
           @fadeInOut
           (scroll)="onSearchResultsScroll($event)">

        <!-- New Tabs for Search Results / Customer -->
        <div class="result-tabs-container">
          <!-- Customers tab: plain text label, no button -->
          <span *ngIf="selectedBadgeId === 1" class="search-result-label">
            Search Results
            <span class="tab-count tab-count-skeleton" *ngIf="isSkeletonLoader"></span>
            <span class="tab-count" *ngIf="!isSkeletonLoader && searchResultTabCount !== null">{{ searchResultTabCount }}</span>
          </span>

          <!-- All other tabs: button -->
          <button
            *ngIf="selectedBadgeId !== 1"
            class="result-tab"
            [ngClass]="{'active': selectedResultTab === 'search-results'}"
            [disabled]="isSkeletonLoader"
            (click)="onResultTabChange('search-results')">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.5001 17.5L13.9167 13.9167" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Search Result</span>
            <span class="tab-count tab-count-skeleton" *ngIf="isSkeletonLoader"></span>
            <span class="tab-count" *ngIf="!isSkeletonLoader && searchResultTabCount !== null">{{ searchResultTabCount }}</span>
          </button>

          <button
            *ngIf="selectedBadgeId !== 1"
            class="result-tab"
            [ngClass]="{'active': selectedResultTab === 'customer'}"
            [disabled]="isSkeletonLoader"
            (click)="onResultTabChange('customer')">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0652 12.8512 14.2174 12.5 13.3333 12.5H6.66667C5.78261 12.5 4.93477 12.8512 4.30964 13.4763C3.68452 14.1014 3.33333 14.9493 3.33333 15.8333V17.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 10 2.5C8.15905 2.5 6.66667 3.99238 6.66667 5.83333C6.66667 7.67428 8.15905 9.16667 10 9.16667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Customer</span>
            <span class="tab-count tab-count-skeleton" *ngIf="isSkeletonLoader"></span>
            <span class="tab-count" *ngIf="!isSkeletonLoader && customerTabCount !== null">{{ customerTabCount }}</span>
          </button>
        </div>

        <!-- Show skeleton loader when loading -->
        <div *ngIf="isSkeletonLoader" @fadeInOut class="skeleton-loader-container">
          <div class="skeleton-item" *ngFor="let item of [1,2,3,4,5]">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-content">
              <div class="skeleton-line skeleton-line-title"></div>
              <div class="skeleton-line skeleton-line-text"></div>
              <div class="skeleton-line skeleton-line-text short"></div>
            </div>
          </div>
        </div>

        <!-- Show results when not loading -->
        <div *ngIf="!isSkeletonLoader" @fadeInOut>

        <div *ngFor="let result of searchResults; let i = index" (click)="onResultClick(result)">

          <!-- Customer Badge Layout (unchanged) -->
          <div *ngIf="selectedBadgeId === 1 && result.type === 'Customers'"
               class="suggestion-item customer-tab-layout">
            <div class="result-details w-100">
              <!-- ID + Name in one line -->
              <div class="customer-header">
                <div class="customer-id-badge" [innerHTML]="getHighlightedText(result, 'customerId')">
                </div>
                <div class="customer-name-large">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </div>
              </div>

              <!-- Email + Phone in one line -->
              <div class="customer-contact-row">
                <div class="d-flex align-items-center">
                  <i class="fa fa-envelope mr-2"></i>
                  <span class="text-light" [innerHTML]="getHighlightedText(result, 'email')"></span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="fa-solid fa-phone mr-2"></i>
                  <span class="text-light" [innerHTML]="getHighlightedText(result, 'primaryPhone')"></span>
                </div>
              </div>
            </div>
          </div>

          <!-- Orders Card Layout (new design) -->
          <div *ngIf="result.type === 'Orders'" class="search-item-card">
            <!-- Left Section: Customer ID Badge + Customer Name -->
            <div class="search-item-left">
              <div class="search-id-badge-new" [innerHTML]="getHighlightedText(result, 'customerId')">
              </div>
              <div class="search-entity-name-wrapper">
                <div class="search-entity-name">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </div>

              </div>
            </div>

            <!-- Center Section: Order Details - Split into two containers -->
            <div class="search-item-center">
              <!-- First Container: Order Details -->
              <div class="search-details-container">
                <!-- Status Badge -->
                <div class="search-detail-row">
                 <div class="search-sub-info">
                    <span class="search-detail-label" >Order ID: </span><span class="search-detail-value">#<span [innerHTML]="getHighlightedText(result, 'id')"></span></span>
                  </div>
                </div>
                <div class="search-detail-row">
                  <span class="search-detail-label">Status:</span>
                  <span
                    class="text-badge search-detail-value"
                    [ngClass]="{
                      'textt-success': orderBadgeGroups['badge-success'].includes(result.orderStatus),
                      'textt-danger': orderBadgeGroups['badge-danger'].includes(result.orderStatus),
                      'textt-primary': orderBadgeGroups['badge-primary'].includes(result.orderStatus),
                      'textt-warning': orderBadgeGroups['badge-warning'].includes(result.orderStatus),
                      'textt-secondary': orderBadgeGroups['badge-secondary'].includes(result.orderStatus)
                    }">
                    {{ result.orderStatus }}
                  </span>
                </div>

                <!-- Total Amount -->
                <div class="search-detail-row">
                  <span class="search-detail-label">Total Amount:</span>
                  <span class="search-detail-value">${{ result.totalAmount }}</span>
                </div>
              </div>

              <!-- Second Container: Date and Time -->
              <div class="search-datetime-container">
                <div class="search-item-right">
                  <span class="timestamp-date">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'date') }}
                  </span>
                  <span class="separator">|</span>
                  <span class="timestamp-time">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'time') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Subscriptions Card Layout (new design) -->
          <div *ngIf="result.type === 'Subscriptions'" class="search-item-card">
            <!-- Left Section: Customer ID Badge + Customer Name -->
            <div class="search-item-left">
              <div class="search-id-badge-new" [innerHTML]="getHighlightedText(result, 'customerId')">
              </div>
              <div class="search-entity-name-wrapper">
                <div class="search-entity-name">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </div>

              </div>
            </div>

            <!-- Center Section: Subscription Details - Split into two containers -->
            <div class="search-item-center">
              <!-- First Container: Subscription Details -->
              <div class="search-details-container">
                <!-- Status Badge -->
                 <div class="search-detail-row">
                  <span class="search-detail-label">Subscription ID: </span>
                  <span class="search-detail-value">#<span [innerHTML]="getHighlightedText(result, 'subscriptionId')"></span></span>
                 </div>

                <div class="search-detail-row">
                  <span class="search-detail-label">Status:</span>
                  <span
                    class="text-badge p-0"
                    [ngClass]="{
                      'textt-success': result.status?.toLowerCase() === 'active',
                      'textt-warning': result.status?.toLowerCase() === 'suspend',
                      'textt-primary': result.status?.toLowerCase() === 'deactivated',
                      'textt-danger': result.status?.toLowerCase() === 'cancelled'
                    }">
                    {{ result.status }}
                  </span>
                </div>
              </div>

              <!-- Second Container: Next Billing Date -->
              <div class="search-datetime-container">
                <div class="search-item-right">
                  <span class="search-detail-label">Next Billing:</span>
                  <span class="timestamp-date">
                    {{ commonService.formatToLocalDateTime(result.nextBillingDate, 'date') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets Card Layout (new design) -->
          <div *ngIf="result.type === 'Tickets'" class="search-item-card ticket-card">
            <!-- First Row: Customer ID + Name on left, Status + Priority on right -->
            <div class="ticket-header-row">
              <div class="search-item-left">
                <div class="search-id-badge-new" [innerHTML]="getHighlightedText(result, 'customerId')">
                </div>
                <div class="search-entity-name">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </div>
              </div>

              <div class="ticket-badges">
                <!-- Status Badge (no label, just value) -->
                <span
                  class="custom-badge "
                  [ngClass]="{
                    'badge-success': result.status === 'Resolved' || result.status === 'Closed',
                    'badge-danger': result.status === 'On Hold' || result.status === 'Open',
                    'badge-primary': result.status === 'In Progress',
                    'badge-warning': result.status === 'Escalated'
                  }">
                  {{ result.status }}
                </span>


              </div>
            </div>

            <!-- Second Row: Ticket Details - Split into two containers -->
            <div class="search-item-center">
              <!-- First Container: Ticket Details -->
              <div class="search-details-container">
                <!-- Ticket ID -->
                <div class="search-detail-row">
                  <span class="search-detail-label">Ticket ID:</span>
                  <span class="search-detail-value">#<span [innerHTML]="getHighlightedText(result, 'id')"></span></span>
                </div>

                <!-- Ticket Type -->
                <div class="search-detail-row">
                  <span class="search-detail-label">Type:</span>
                  <span class="search-detail-value">{{ result.ticketType }}</span>
                </div>
              </div>

              <!-- Second Container: Date and Time -->
              <div class="search-datetime-container">
                <div class="search-item-right">
                  <span class="timestamp-date">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'date') }}
                  </span>
                  <span class="separator">|</span>
                  <span class="timestamp-time">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'time') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Payments Card Layout (new design) -->
          <div *ngIf="result.type === 'Payments'" class="search-item-card payment-card">
            <!-- First Row: Customer Info on left, Card details on right -->
            <div class="payment-header-row">
              <div class="search-item-left">
                <div class="search-id-badge-new" [innerHTML]="getHighlightedText(result, 'customerId')">
                </div>
                <div class="search-entity-name">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </div>
                 <!-- <div class="search-detail-row search-id-badge-new">
                <span class="search-detail-label">Payment ID:</span>
                <span class="search-detail-value" [innerHTML]="getHighlightedText(result, 'id')"></span>
              </div> -->
              </div>

              <!-- Card Number + Card Type Badge on right -->
              <div class="payment-card-info">
                <span class="search-detail-label" [innerHTML]="getHighlightedText(result, 'CardNumber')"></span>
                <span class="card-brand-badge">
                  <img src="assets/credit-cards/visa.png" alt="Visa" *ngIf="result.CardType?.toLowerCase().includes('visa')" class="card-brand-icon">
                  <img src="assets/credit-cards/table-master-icon.svg" alt="Mastercard" *ngIf="result.CardType?.toLowerCase().includes('mastercard')" class="card-brand-icon">
                  <img src="assets/credit-cards/american-express.png" alt="American Express" *ngIf="result.CardType?.toLowerCase().includes('american express') || result.CardType?.toLowerCase().includes('amex')" class="card-brand-icon">
                </span>
              </div>
            </div>

            <!-- Second Row: Transaction Details - Split into two containers -->
            <div class="search-item-center">
              <!-- First Container: Transaction Details -->
              <div class="search-details-container">
                <div class="search-detail-row">
                  <span class="search-detail-label">Transaction ID:</span>
                  <span class="search-detail-value" [innerHTML]="getHighlightedText(result, 'tracId')"></span>
                </div>

                <div class="search-detail-row">
                  <span class="search-detail-label">Transaction Amount:</span>
                  <span class="search-detail-value">${{ result.amount }}</span>
                </div>
              </div>

              <!-- Second Container: Date and Time -->
              <div class="search-datetime-container">
                <div class="search-item-right">
                  <span class="timestamp-date">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'date') }}
                  </span>
                  <span class="separator">|</span>
                  <span class="timestamp-time">
                    {{ commonService.formatToLocalDateTime(result.createdDate, 'time') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Other types (Customers non-badge, Addresses) - Keep existing layout -->
          <div *ngIf="!(selectedBadgeId === 1 && result.type === 'Customers') && result.type !== 'Orders' && result.type !== 'Subscriptions' && result.type !== 'Tickets' && result.type !== 'Payments'"
               class="suggestion-item d-flex align-items-center justify-content-between">
            <div class="result-details ml-2">
              <div class="result-name">
                <ng-container *ngIf="result.type === 'Customers'">
                  {{ result.firstName | titlecase }} {{ result.lastName | titlecase }}
                </ng-container>
                <ng-container *ngIf="result.type === 'Addresses'">
                  Address ID: {{ result.id }}
                </ng-container>
              </div>

              <ng-container *ngIf="result.type === 'Customers'">
                <div class="d-flex flex-wrap align-items-center">
                  <div class="d-flex align-items-center mr-3">
                    <i class="fa fa-envelope text-primary mr-1"></i>
                    <span class="text-secondary"><small>{{ result.email }}</small></span>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fa-solid fa-phone text-success mr-1"></i>
                    <span class="text-secondary"><small>{{ result.primaryPhone }}</small></span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="result.type === 'Addresses'">
                <div class="result-details">
                  <strong class="text-primary">Service Address:</strong>
                  <span class="text-dark">{{ result.serviceAddress1 }}, {{ result.serviceAddress2 || '' }}</span>
                </div>
                <div class="result-details">
                  <strong class="text-secondary">City ID:</strong>
                  <span class="text-muted">{{ result.cityId }}</span>
                </div>
                <div class="result-details">
                  <strong class="text-secondary">Zip Code:</strong>
                  <span class="text-muted">{{ result.zipId }}</span>
                </div>
              </ng-container>
            </div>

            <div class="div" *ngIf="result.type === 'Customers'">
              <div class="custom-badge">
                # {{ result.customerId }}
              </div>
            </div>
          </div>

        </div>

        <!-- Loading More Indicator -->
        <div class="loading-more-container" *ngIf="isLoadingMore">
          <!-- <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div> -->
          <span class="ml-2">Loading more results...</span>
        </div>

        <!-- Load More Button -->
        <div class="text-center py-3" *ngIf="hasMoreResults && !isLoadingMore && searchResults.length > 0">
          <button class="btn btn-outline-primary btn-sm" (click)="loadMoreResults()">
            <!-- <i class="fas fa-chevron-down mr-2"></i> -->
            <!-- Load More (Page {{ currentPage + 1 }} of {{ totalPages }}) -->
          </button>
        </div>

        <!-- No More Results Message -->
        <div class="text-center py-2 text-muted small" *ngIf="!hasMoreResults && searchResults.length > 0 && !isLoadingMore">
          <i class="fas fa-check-circle mr-1"></i>
          All results loaded ({{ searchResults.length }} of {{ totalResults }})
        </div>

        <div class="no-search-suggestions" *ngIf="noResultFound && !hasSearchResults()">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" class="no-results-image">
            <circle cx="11" cy="11" r="7" stroke="#C0C0C0" stroke-width="1.5"/>
            <path d="M16.5 16.5L21 21" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M8.5 11h5M11 8.5v5" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round"/>
            <line x1="8" y1="8" x2="14" y2="14" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <p class="no-results-text">No Results Found<br><span class="no-results-sub">No search items available.<br>Try typing to see suggestions.</span></p>
        </div>
        </div>
      </div>
  </div>
